import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbIndexApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbIndex';
    }

    /**
     * 获取表下索引
     * @param tableId 
     * @returns 
     */
    public getDbIndexByTableId(tableId: number, devProd: string) {
        return this.send({ tableId, devProd }, "getDbIndexByTableId", Methods.GET);
    }

    /**
     * 批量新增或修改
     * @param datas 
     * @returns 
     */
    public dbIndexSaveOrUpdate(datas) {
        return this.send(datas, 'dbIndexSaveOrUpdate', Methods.POST);
    }

    /**
     * 删除DbIndex
     * @param indexId 
     * @returns 
     */
    public deleteDbIndex(indexId) {
        return this.send({}, "deleteDbIndex?id=" + indexId, Methods.POST);
    }

    /**
     * 获取索引
     * @param aboveIndexId 
     * @param devProd 
     * @returns 
     */
    public getDbIndexByAboveIndexId(aboveIndexId, devProd) {
        return this.send({ aboveIndexId, devProd }, "getDbIndexByAboveIndexId", Methods.GET);
    }

}